/* custom-loop-top.js
* Prestige / ScrollCarousel 用：端を越えたら反対端へループ
* - クローン要素は作らない（テーマの内部計算を崩さない）
* - スワイプ（タッチ）もボタン操作も対応
* - ジャンプ時は scroll-snap を一時的に外してカクつきを抑制
*/

(function () {
 'use strict';

 // ===== 共通ユーティリティ =====
 const addOnce = (el, type, handler, opts = {}) => el.addEventListener(type, handler, { ...opts });
 const now = () => Date.now();

 // snapを一時的に外してから select する（自然なアニメに）
 const jumpTo = (carousel, index, { instant = false } = {}) => {
   const prev = carousel.style.scrollSnapType;
   carousel.style.scrollSnapType = 'none';

   // select はテーマが用意している公開メソッド
   carousel.select(index, { instant });

   // 少し遅らせて snap 復帰（復帰しないと通常操作がカクつく）
   setTimeout(() => {
     carousel.style.scrollSnapType = prev || '';
   }, instant ? 0 : 320); // だいたいテーマのアニメ長と同程度
 };

 // 横スワイプの簡易検出（縦スクロールは無視）
 const attachSwipeLoop = (carousel) => {
   let sx = 0, sy = 0, st = 0;
   const THRESHOLD_PX = 60;
   const THRESHOLD_MS = 500;

   addOnce(carousel, 'touchstart', (e) => {
     const t = e.touches[0];
     sx = t.clientX; sy = t.clientY; st = now();
   }, { passive: true });

   addOnce(carousel, 'touchend', (e) => {
     if (!e.changedTouches || !e.changedTouches[0]) return;
     const t = e.changedTouches[0];
     const dx = t.clientX - sx;
     const dy = t.clientY - sy;
     const dt = now() - st;

     // 縦強め or 長押しは除外
     if (Math.abs(dy) > Math.abs(dx) || dt > THRESHOLD_MS) return;

     const i = carousel.selectedIndex;
     const last = carousel.cells.length - 1;

     // 左へ（次へ）
     if (dx < -THRESHOLD_PX && i === last) {
       requestAnimationFrame(() => jumpTo(carousel, 0, { instant: false }));
     }
     // 右へ（前へ）
     if (dx > THRESHOLD_PX && i === 0) {
       requestAnimationFrame(() => jumpTo(carousel, last, { instant: false }));
     }
   });
 };

 // 外部の prev/next ボタンでも端越え時にループさせる
 const attachButtonLoop = (carousel) => {
   const id = carousel.id;
   // aria-controls が一致するボタン群（Prestigeの構造を想定）
   const nextButtons = id
     ? document.querySelectorAll(`[aria-controls="${id}"] carousel-next-button, carousel-next-button[aria-controls="${id}"]`)
     : document.querySelectorAll('carousel-next-button[aria-controls]');
   const prevButtons = id
     ? document.querySelectorAll(`[aria-controls="${id}"] carousel-prev-button, carousel-prev-button[aria-controls="${id}"]`)
     : document.querySelectorAll('carousel-prev-button[aria-controls]');

   nextButtons.forEach(host => {
     host.addEventListener('click', () => {
       const i = carousel.selectedIndex;
       const last = carousel.cells.length - 1;
       if (i === last) {
         requestAnimationFrame(() => jumpTo(carousel, 0, { instant: false }));
       }
     });
   });

   prevButtons.forEach(host => {
     host.addEventListener('click', () => {
       const i = carousel.selectedIndex;
       const last = carousel.cells.length - 1;
       if (i === 0) {
         requestAnimationFrame(() => jumpTo(carousel, last, { instant: false }));
       }
     });
   });
 };

 // 対象の ScrollCarousel にループ機能を付与
 const enableLoopForCarousel = (carousel) => {
   if (!carousel || typeof carousel.select !== 'function') return;
   attachSwipeLoop(carousel);
   attachButtonLoop(carousel);
 };

 // ===== ① TOPページ：特定IDプレフィックスのカルーセル群 =====
 document.addEventListener('DOMContentLoaded', () => {
   const carousels = document.querySelectorAll(
     'scroll-carousel[id^="featured-collections-product-list-carousel-collection_"]'
   );
   carousels.forEach((c) => {
     // 2枚未満はループ不要
     if (!c.cells || c.cells.length < 2) return;
     enableLoopForCarousel(c);
   });
 });

 // ===== ② 商品ページ（Prestigeの商品メディアギャラリー） =====
 document.addEventListener('DOMContentLoaded', () => {
   const isProduct = window.themeVariables?.settings?.pageType === 'product'
     || document.body.classList.contains('template-product');
   if (!isProduct) return;

   const gallery = document.querySelector(
     'product-media scroll-carousel, scroll-carousel[aria-label="product-media"], scroll-carousel.product-gallery'
   );
   if (!gallery || !gallery.cells || gallery.cells.length < 2) return;

   enableLoopForCarousel(gallery);
 });

})();

/* custom-loop-top.js */
(function () {
 'use strict';

 const addOnce = (el, type, handler, opts = {}) => el.addEventListener(type, handler, { ...opts });
 const now = () => Date.now();

 const jumpTo = (carousel, index, { instant = false } = {}) => {
   const prev = carousel.style.scrollSnapType;
   carousel.style.scrollSnapType = 'none';
   carousel.select(index, { instant });
   setTimeout(() => {
     carousel.style.scrollSnapType = prev || '';
   }, instant ? 0 : 320);
 };

 const attachSwipeLoop = (carousel) => {
   let sx = 0, sy = 0, st = 0;
   const THRESHOLD_PX = 60, THRESHOLD_MS = 500;

   carousel.addEventListener('touchstart', (e) => {
     const t = e.touches[0];
     sx = t.clientX; sy = t.clientY; st = now();
   }, { passive: true });

   carousel.addEventListener('touchend', (e) => {
     if (!e.changedTouches || !e.changedTouches[0]) return;
     const t = e.changedTouches[0];
     const dx = t.clientX - sx;
     const dy = t.clientY - sy;
     const dt = now() - st;
     if (Math.abs(dy) > Math.abs(dx) || dt > THRESHOLD_MS) return;

     const i = carousel.selectedIndex;
     const last = carousel.cells.length - 1;

     if (dx < -THRESHOLD_PX && i === last) requestAnimationFrame(() => jumpTo(carousel, 0));
     if (dx > THRESHOLD_PX && i === 0) requestAnimationFrame(() => jumpTo(carousel, last));
   });
 };

 const attachButtonLoop = (carousel) => {
   const id = carousel.id;
   const nextButtons = id
     ? document.querySelectorAll(`[aria-controls="${id}"] carousel-next-button, carousel-next-button[aria-controls="${id}"]`)
     : document.querySelectorAll('carousel-next-button[aria-controls]');
   const prevButtons = id
     ? document.querySelectorAll(`[aria-controls="${id}"] carousel-prev-button, carousel-prev-button[aria-controls="${id}"]`)
     : document.querySelectorAll('carousel-prev-button[aria-controls]');

   nextButtons.forEach(btn => {
     btn.addEventListener('click', () => {
       if (carousel.selectedIndex === carousel.cells.length - 1) {
         requestAnimationFrame(() => jumpTo(carousel, 0));
       }
     });
   });

   prevButtons.forEach(btn => {
     btn.addEventListener('click', () => {
       if (carousel.selectedIndex === 0) {
         requestAnimationFrame(() => jumpTo(carousel, carousel.cells.length - 1));
       }
     });
   });
 };

 const enableLoopForCarousel = (carousel) => {
   if (!carousel || typeof carousel.select !== 'function') return;
   attachSwipeLoop(carousel);
   attachButtonLoop(carousel);
 };

 // ===== ① TOPページ =====
 document.addEventListener('DOMContentLoaded', () => {
   const carousels = document.querySelectorAll(
     'scroll-carousel[id^="featured-collections-product-list-carousel-collection_"]'
   );
   carousels.forEach((c) => {
     if (!c.cells || c.cells.length < 2) return;
     enableLoopForCarousel(c);
   });
 });

 // ===== ② 商品ページ =====
 const initProductGalleryLoop = () => {
   const isProduct = window.themeVariables?.settings?.pageType === 'product'
     || document.body.classList.contains('template-product');
   if (!isProduct) return;

   const gallery = document.querySelector('product-media scroll-carousel, scroll-carousel.product-gallery, .product-gallery scroll-carousel');
   if (gallery && gallery.cells && gallery.cells.length >= 2) {
     enableLoopForCarousel(gallery);
   }
 };

 // DOMロード後 & 遅延読込にも対応
 document.addEventListener('DOMContentLoaded', initProductGalleryLoop);
 document.addEventListener('shopify:section:load', initProductGalleryLoop);
})();